import React from "react";
import "../../../styles/utils/modal/CustomStartModal.scss";
import useBGM from "../../../hooks/common/useBGM";
import useAppTranslation from "../../../hooks/useAppTranslation";

export default function CustomStartModal({ onNavigateHome, onStart, onSkip }) {
  const { t } = useAppTranslation("components/utils/customStartModal");

  useBGM("/audio/customBook/custom-modal-music.mp3");

  return (
    <div className="custom-start-modal">
      <div className="modal-container">
        <h2>{t("headline")}</h2>
        <h1>{t("title")}</h1>
        <div className="subtitle-box">
          <figure>
            <img
              src="/images/utils/modal/customStartModal/sub_title.svg"
              alt={t("alts.subtitleBackground")}
            />
          </figure>
          <span>{t("subtitle")}</span>
        </div>
        <button onClick={onStart}>{t("actions.start")}</button>
      </div>
      <figure className="home" onClick={onNavigateHome}>
        <img
          src="/images/utils/modal/customStartModal/home.svg"
          alt={t("alts.home")}
        />
      </figure>
      <figure className="asset1">
        <img
          src="/images/utils/modal/customStartModal/asset1.svg"
          alt={t("alts.decoration")}
        />
      </figure>
      <figure className="asset2">
        <img
          src="/images/utils/modal/customStartModal/asset2.svg"
          alt={t("alts.decoration")}
        />
      </figure>
      <figure className="asset3">
        <img
          src="/images/utils/modal/customStartModal/asset3.svg"
          alt={t("alts.decoration")}
        />
      </figure>
      <figure className="asset4">
        <img
          src="/images/utils/modal/customStartModal/asset4.svg"
          alt={t("alts.decoration")}
        />
      </figure>
      {/* <button className="skip-btn" onClick={onSkip}>
        skip
      </button> */}
    </div>
  );
}
